/**
 * ADR-0013 — Sales payment-channel filter (Reporting).
 * Buckets align with finance register income + créance portion.
 */

import { resolveSaleUnpaidAmount } from '../../customers/balance/saleBalance';
import { resolveSaleRegisterIncome } from '../checkout';

/**
 * @param {object} sale
 * @param {'all'|'cash'|'electronic'|'credit'|string} filter
 * @returns {boolean}
 */
export function saleMatchesPaymentFilter(sale, filter = 'all') {
  if (!filter || filter === 'all') return true;
  if (filter === 'credit') {
    return resolveSaleUnpaidAmount(sale) > 0;
  }
  const income = resolveSaleRegisterIncome(sale);
  if (filter === 'cash') return income.channel === 'cash' && income.amount > 0;
  if (filter === 'electronic') return income.channel === 'electronic' && income.amount > 0;
  return false;
}

/**
 * @param {Array} sales
 * @param {'all'|'cash'|'electronic'|'credit'|string} filter
 * @returns {Array}
 */
export function filterSalesByPayment(sales, filter = 'all') {
  if (!filter || filter === 'all') return Array.isArray(sales) ? sales : [];
  return (Array.isArray(sales) ? sales : []).filter((sale) =>
    saleMatchesPaymentFilter(sale, filter)
  );
}
